module.exports = "/_next/static/images/top-42f3808cc6ff6803cd520c22e852b535.jpeg";